import { render, staticRenderFns } from "./IosNotificationDialog.vue?vue&type=template&id=2d1a2c16"
import script from "./IosNotificationDialog.vue?vue&type=script&lang=js"
export * from "./IosNotificationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d1a2c16')) {
      api.createRecord('2d1a2c16', component.options)
    } else {
      api.reload('2d1a2c16', component.options)
    }
    module.hot.accept("./IosNotificationDialog.vue?vue&type=template&id=2d1a2c16", function () {
      api.rerender('2d1a2c16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/conversations/chat-box/IosNotificationDialog.vue"
export default component.exports